import type { IconSvgObject } from './types';

const ArrowExpandDiagonal02Icon: IconSvgObject = [
  ["path", { d: "M16 8L8 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 3L3 3.00049M3 3.00049V7.00052M3 3.00049L9 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 21H21M21 21V17M21 21L15 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowExpandDiagonal02Icon;
